<template>
        <div>

            <div class="container fluid">
                    <table class='table  table-responsive '>
                        <tbody >
                            <div>
                                <tr  v-for="(item,index) in singleMessageThread" :key="item.id" :id='"messageindex" + index'>
                                <div v-if="item.iAmSender" style="margin-left:50px"> 
                                    <footer class="blockquote-footer"><cite title="Source Title">{{item.sentBy}}</cite> on {{item.date}}</footer>
                                    <td  class="bg-success" style="border-radius: 10px;margin-left:50px"> <p class="text-white">{{item.message}}</p></td>
                                </div>
                                <div v-else> 
                                    <footer class="blockquote-footer"><cite title="Source Title">{{item.sentBy}}</cite> on {{item.date}}</footer>
                                    <td  class="bg-primary"  style="border-radius: 10px;"><p class="text-white">{{item.message}}</p></td>
                                </div>
                                </tr>
                            </div>
                        </tbody>
                </table>

                <sendmessage  :receiverId="getReceiverId"/>
                <br>
                <!-- End fake div to scroll -->
                <div id="scrollend"></div>
                <div><pagefooter/></div>
            </div>
        </div>
</template>

<script>
/*
module.exports = {
  props: ['personName']
}*/

    import { mapState } from 'vuex'
    import { currentUser, zipcodesCollection } from '../firebaseConfig'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')
    import firebase from 'firebase/app';
    import Sendmessage from './Sendmessage'
    import Pagefooter from './Pagefooter'

export default {
    
        components: {
            Sendmessage,
            Pagefooter
            },

            data() {
            return {
                showSuccess: false,
                theMessage:'',
                messagesArray:[],
                theMessage:'',
                originalMessageObject:{},
                performingRequest:false,
                showingThread:false,
                receiverId:''
            }
        },
        updated(){ 
            var elem = this.$el
            elem.scrollTop = elem.clientHeight;
            },

        computed: {
            ...mapState(['userProfile', 'currentUser', 'userMessagesArray', 'isBrewer', 'singleMessageThread', 'activeMessageThreadInfo']),
            getReceiverId: function () {
                if(parseInt(this.userProfile.isbrewer)==1||parseInt(this.userProfile.isbrewer)==2) this.receiverId = this.activeMessageThreadInfo.pubId
                else this.receiverId = this.activeMessageThreadInfo.brewerId
                
                if(this.activeMessageThreadInfo.pubId==this.currentUser.uid) this.receiverId = this.activeMessageThreadInfo.brewerId
                else this.receiverId = this.activeMessageThreadInfo.pubId

                return this.receiverId

            },
        },
        methods:{
            addMessageToArray(){
                var receiverId
                if(parseInt(this.userProfile.isbrewer)==1||parseInt(this.userProfile.isbrewer)==2) receiverId = this.activeMessageThreadInfo.pubId
                else receiverId = this.activeMessageThreadInfo.brewerId

                var messageObject = {}
                messageObject.message = this.theMessage
                messageObject.senderId = this.currentUser.uid
                messageObject.sentBy = this.userProfile.company
                messageObject.createdOn = new Date()
                messageObject.readByReceiver = 0
                
                var min=11111111111111111; 
                var max=99999999999999999;  
                var randomId = Math.floor(Math.random() * (+max - +min)) + +min; 

                messageObject.id = randomId
                
                var theDocId
                if (this.currentUser.uid<receiverId) theDocId = this.currentUser.uid + receiverId
                else theDocId = receiverId + this.currentUser.uid

                //Update message info
                fb.messagesCollection.doc(theDocId).update({ "messageinfo.lastMessage": this.theMessage})
                fb.messagesCollection.doc(theDocId).update({ "messageinfo.createdOn": new Date()})
                fb.messagesCollection.doc(theDocId).update({ "messageinfo.senderId": this.currentUser.uid})
                fb.messagesCollection.doc(theDocId).update({ "messageinfo.readByReceiver": 0})

                //Add message to array
                fb.messagesCollection.doc(theDocId).update({
                    messages: firebase.firestore.FieldValue.arrayUnion({message: messageObject})
                    });
                    this.theMessage = ''
                    window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
                    let elmnt = document.getElementById('bottom');
                    elmnt.scrollIntoView(false);
                    this.scrollToEnd()

            },
            scrollToEnd: function() {    	
                if(this.$el){
                    var container = this.$el.querySelector("#scrollend");
                    if(container)
                    container.scrollTop = container.scrollHeight;
                }
                
            },
        },

        updated(){      
            var elem = this.$el
            elem.scrollTop = elem.clientHeight;
            this.scrollToEnd()
            var messagesLength = this.singleMessageThread.messagesLength
            var elementId = 'messageindex'+(messagesLength-1).toString()
            document.getElementById('scrollend').scrollIntoView();
        },
        mounted(){
            this.scrollToEnd()
        },

        
}


</script>

<style scoped>
  h2 {
    font-size: 40px;
    color: mediumseagreen;
  }

</style>